import React from 'react'
import Select from '../TermoVisita/ModulosCrefito/Select'
import Input from '../TermoVisita/ModulosCrefito/Input'
import Observacoes from '../TermoVisita/ModulosCrefito/Observacoes'

import { useSelector } from 'react-redux'

const TiposDespacho = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if (condicional[modulo]) var qtdFicha = condicional[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <div style={{ textAlign: "left" }}>
                    <Select label="Tipo do Despacho" nome="tipo" modulo={modulo} index={n}
                        componentDisplay="inline-grid" widthWeb="40vw" widthMobile="80vw" marginR="3vw"
                        array={[
                            "DESCUMPRIMENTO DA RESOLUÇÃO 139/92 - ATENDIMENTO DA DETERMINAÇÃO",
                            "DESCUMPRIMENTO DA RESOLUÇÃO 139/92 – NÃO ATENDIMENTO DA DETERMINAÇÃO",
                            "DESCUMPIRMENTO DA RESOLUÇÃO COFFITO 08/1978 – DO ATENDIMENTO",
                            "DESCUMPIRMENTO DA RESOLUÇÃO COFFITO 08/1978 – DO NÃO ATENDIMENTO",
                            "DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 37/84 – DO ATENDIMENTO",
                            "DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 37/84 – DO NÃO ATENDIMENTO",
                            "DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 37/84- ATIVIDADE SECUNDÁRIA",
                            "DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 414 E/OU 415/12",
                            "DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 414 E/OU 415/12 (Sem AI)",
                            "ALTERAÇÃO DE DADOS CADASTRAIS",
                            "ATO FISCALIZATÓRIO NÃO REALIZADO",
                            "SERVIÇO SEM IRREGULARIDADES",
                            "SERVIÇO DESATIVADO SEM REGISTRO",
                            "EM BRANCO",
                            "ESTABELECIMENTO SEM EQUIPE PRÓPRIA",
                            "DESCUMPRIMENTO DA RDC 07/2010 – ANVISA",
                            "ATRIBUIÇÕES EXTRA COMPETÊNCIA PROFISSIONAL",
                            "PRESTAÇÃO DE ASSISTÊNCIA EM HOME CARE",
                            "SERVIÇO NÃO DISPÕE DE ASSISTÊNCIA",
                            "SERVIÇO DESATIVADO COM SOLICITAÇÃO DE BAIXA DE REGISTRO",
                            "SERVIÇO DESATIVADO SEM REQUERIMENTO DE BAIXA DE REGISTRO",
                        ]} />
                    {RenderTipo()}
                </div>
            )

            function RenderTipo() {
                if (condicional[modulo][n]["tipo"] === "DESCUMPRIMENTO DA RESOLUÇÃO 139/92 - ATENDIMENTO DA DETERMINAÇÃO"
                    || condicional[modulo][n]["tipo"] === "DESCUMPRIMENTO DA RESOLUÇÃO 139/92 – NÃO ATENDIMENTO DA DETERMINAÇÃO"
                    || condicional[modulo][n]["tipo"] === "DESCUMPIRMENTO DA RESOLUÇÃO COFFITO 08/1978 – DO NÃO ATENDIMENTO"
                    || condicional[modulo][n]["tipo"] === "SERVIÇO SEM IRREGULARIDADES") {
                    return (
                        <div>
                            <Input label="Data da fiscalização" nome="data" modulo={modulo} index={n} tipo="date"
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipo"] === "DESCUMPIRMENTO DA RESOLUÇÃO COFFITO 08/1978 – DO ATENDIMENTO"
                    || condicional[modulo][n]["tipo"] === "DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 37/84 – DO ATENDIMENTO") {
                    return (
                        <div>
                            <Input label="Data da fiscalização" nome="data" modulo={modulo} index={n} tipo="date"
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Número da Registro" nome="numeroCertidao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipo"] === "DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 37/84 – DO NÃO ATENDIMENTO") {
                    return (
                        <div>
                            <Input label="Data da fiscalização" nome="data" modulo={modulo} index={n} tipo="date"
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Proprietário da Empresa" nome="proprietario" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipo"] === "DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 414 E/OU 415/12") {
                    return (
                        <div>
                            <Input label="Data da fiscalização" nome="data" modulo={modulo} index={n} tipo="date"
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Resolução COFFITO" nome="resolucao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipo"] === "DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 414 E/OU 415/12 (Sem AI)") {
                    return (
                        <div>
                            <Input label="Data da fiscalização" nome="data" modulo={modulo} index={n} tipo="date"
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Resolução COFFITO" nome="resolucao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipo"] === "EM BRANCO") {
                    return (
                        <div>
                            <Observacoes widthWeb="83vw" widthMobile="80vw" modulo={modulo} index={n}
                                label="Digite o texto do Despacho" nome="textoBranco" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipo"] === "DESCUMPRIMENTO DA RDC 07/2010 – ANVISA") {
                    return (
                        <div>
                            <Input label="Data da fiscalização" nome="data" modulo={modulo} index={n} tipo="date"
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Observacoes widthWeb="83vw" widthMobile="80vw" modulo={modulo} index={n}
                                label="Digite o texto do Despacho" nome="textoBranco" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipo"] === "ATRIBUIÇÕES EXTRA COMPETÊNCIA PROFISSIONAL") {
                    return (
                        <div>
                            <Input label="Data da fiscalização" nome="data" modulo={modulo} index={n} tipo="date"
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Observacoes widthWeb="83vw" widthMobile="80vw" modulo={modulo} index={n}
                                label="Digite o texto do Despacho" nome="textoBranco" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipo"] === "SERVIÇO NÃO DISPÕE DE ASSISTÊNCIA") {
                    return (
                        <div>
                            <Select label="Profissão" nome="profissao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="40vw" widthMobile="80vw" marginR="3vw"
                                array={["Fisioterapia", "Terapia Ocupacional"]} />
                        </div>
                    )
                }
            }
        }
        return partes
    }
}

export default TiposDespacho